import {
    Component,
    ElementRef,
    OnInit,
    Renderer2,
} from "@angular/core";

@Component({
    selector: "app-employer",
    templateUrl: "./employer.component.html",
    styleUrl: "./employer.component.scss",
})
export class EmployerComponent implements OnInit {
    constructor(private renderer: Renderer2, private el: ElementRef) {}

    ngOnInit(): void {
        // Dynamically add Calendly CSS
        const link = this.renderer.createElement("link");
        this.renderer.setAttribute(
            link,
            "href",
            "https://assets.calendly.com/assets/external/widget.css"
        );
        this.renderer.setAttribute(link, "rel", "stylesheet");
        this.renderer.appendChild(this.el.nativeElement, link);

        // Dynamically add Calendly JS
        const script = this.renderer.createElement("script");
        this.renderer.setAttribute(
            script,
            "src",
            "https://assets.calendly.com/assets/external/widget.js"
        );
        this.renderer.setAttribute(script, "type", "text/javascript");
        this.renderer.setAttribute(script, "async", "true");
        this.renderer.appendChild(this.el.nativeElement, script);        
    }
}
